import styled from 'styled-components';

import { Checkbox } from '@dreryk/react-components';

export const StyledAllowCustomAppointmentRequestsField = styled(Checkbox)`
   margin-right: auto;
`;
